import Http from "../services/Providers/Http";

const ENDPOINTS = {
  GET_INVOICE: "/api/invoice/getInvoice",
  SET_USER: "/api/invoice/setUser",
  GET_BIN: "/api/invoice/binResult",
  DO_PAYMENT: "/api/invoice/doPayment",
  PRE_INVOICE: "/api/invoice/createInvoiceByGroup",
  UPDATE_PERMISSON: "/api/user/updatepermissions",
  TRANSACTIONS: "/api/staff/getMyTransactions",
  GET_STUDENT_INFO: "/api/invoice/getStudentInvoice",
  RESOLVE_STUDENT: "/api/invoice/resolveStudentInformation",
  APPLY_BALANCE: "/api/invoice/applyBalance"
};

export default {
  getBanksAccounts: (payload, params) => {
    return Http.get(ENDPOINTS.BANK_ACCOUNTS_LIST, params, null, payload);
  },
  resolveStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.RESOLVE_STUDENT, body, params, null, payload);
  },
  getInvoice: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_INVOICE, body, params, null, payload);
  },
  setUser: (body, payload, params) => {
    return Http.post(ENDPOINTS.SET_USER, body, params, null, payload);
  },
  getStudentInfo: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_STUDENT_INFO, body, params, null, payload);
  },
  getBin: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_BIN, body, params, null, payload);
  },
  doPayment: (body, payload, params) => {
    return Http.post(ENDPOINTS.DO_PAYMENT, body, params, null, payload);
  },
  applyBalance: (body, payload, params) => {
    return Http.post(ENDPOINTS.APPLY_BALANCE, body, params, null, payload);
  },
  prepeareInvoice: (body, payload, params) => {
    return Http.post(ENDPOINTS.PRE_INVOICE, body, params, null, payload);
  },
  do3DPayment: (body, payload, params) => {
    return Http.post(payload.AcsUrl, body, params, null, payload);
  },
  do3DPayment: (body, payload, params) => {
    return Http.post(payload.AcsUrl, body, params, null, payload);
  },
  getMyTransactions: (body, payload, params) => {
    return Http.post(ENDPOINTS.TRANSACTIONS, body, params, null, payload);
  },
}; 